export const WorkspaceLoginMfaRequirement = {
    OPTIONAL: 'optional',
    REQUIRED: 'required',
};
